<template>
    <div>
        <div v-for="ShopItemRelatedType in ShopItemRelatedTypes"
             v-if="RelatedShopItems[ShopItemRelatedType.id]"
             :key="ShopItemRelatedType.id"
             class="uk-container uk-container-large uk-margin-medium-bottom">
            <div class="">
                <h4 :id="`related-type-${ShopItemRelatedType.id}`" class="tm-title-color">{{ ShopItemRelatedType.name }}</h4>
            </div>
            <div>
                <div uk-grid
                     class="uk-grid-medium uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l js-list-item-cards uk-grid">
                    <shop-item-block v-for="Product in RelatedShopItems[ShopItemRelatedType.id]"
                                     :key="Product.ShopItem.id"
                                     :shop-item="Product.ShopItem"
                                     :shop-item-prices="RelatedShopItemPrices[Product.ShopItem.id]"
                                     :shop-item-warehouses="RelatedShopItemWarehouses[Product.ShopItem.id]"
                                     :shop-order-item="page.ShopOrderItems[Product.ShopItem.id]"
                                     @buy-shop-item="buy">
                    </shop-item-block>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ShopItemBlock from "../ShopGroup/ShopItemBlock";

    export default {
        components: {ShopItemBlock},
        props: {
            ShopItemRelatedTypes: {
                type: Array,
                default() {
                    return []
                }
            },
            RelatedShopItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            RelatedShopItemPrices: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            RelatedShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopOrderItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            }
        },
        data(){
            return {
                page: {
                    ShopOrderItems: this.ShopOrderItems
                },
            }
        },
        methods:{
            buy(quantity, ShopItem) {
                this.loading = true;
                this.$http.put('/cart/buy', {
                    quantity: quantity,
                    shopItemId: ShopItem.id
                }).then(
                    (response) => {
                        this.page.ShopOrderItems = response.body.data.shopOrderItems;
                        this.loading = false;
                        this.$bus.$emit('update-navbar-cart');
                    }
                )

            },
        }
    }
</script>



// WEBPACK FOOTER //
// RelatedShopItems.vue?367629ee